//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

angular.module('curalate').component('lackingPermissionsLabel', {
  template: 'You don\'t have permission to take this action. Contact a group admin if this is a mistake.',
});
